import React from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { mobile } from '../../styles';

const Tabs = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing.small}px
    ${({ theme }) => theme.spacing.none}px
    ${({ theme }) => theme.spacing.medium}px;
  ${({ reverseTabs }: { reverseTabs?: boolean }) =>
    reverseTabs &&
    `
      flex-direction: row-reverse;
    `}
`;

const TabButton = styled.button`
  ${({ theme }) => theme.subHeader.variants.subHeading3Uppercase.textStyles}
  padding: ${({ theme }) => theme.spacing.tiny}px ${({ theme }) =>
    theme.spacing.small}px;
  min-width: 170px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid transparent;
  font-weight: 500;

  ${mobile`
    min-width: unset;
    width: 100%;
  `}
  &.active {
    border-bottom: 1px solid ${({ theme }) => theme.colors.black};
  }
`;

interface BraCalculatorTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  reverseTabs?: boolean;
}

const BraCalculatorTabs: React.FC<BraCalculatorTabsProps> = ({
  activeTab,
  setActiveTab,
  reverseTabs = false,
}) => {
  return (
    <Tabs reverseTabs={reverseTabs}>
      <TabButton
        type="button"
        data-autotag="braCalculatorTab"
        onClick={() => setActiveTab('calculator')}
        className={activeTab === 'calculator' ? 'active' : ''}
      >
        <FormattedMessage
          id="fit_guide.tab_calculator"
          defaultMessage="Bra Calculator"
        />
      </TabButton>
      <TabButton
        type="button"
        data-autotag="sizeChartTab"
        onClick={() => setActiveTab('sizeChart')}
        className={activeTab === 'sizeChart' ? 'active' : ''}
      >
        <FormattedMessage
          id="fit_guide.tab_size_charts"
          defaultMessage="Size Charts"
        />
      </TabButton>
    </Tabs>
  );
};

export default BraCalculatorTabs;
